import Vue from "vue";
import Router from "vue-router";

import Login from "@/components/Login";
import ForgotPassword from "@/components/ForgotPassword";
import store from "@/store/store";

import Home from "@/components/Home";
import AttendedEvents from "@/components/AttendedEvents";
import IncomingEvents from "@/components/IncomingEvents";
import PastEvents from "@/components/PastEvents";

import Register from "@/components/Register";
import Application from "@/components/Application";
import EventWrapper from "@/components/EventWrapper";
import Event from "@/components/Event";
import EventInfo from "@/components/event/EventInfo";
import Participants from "../pages/Participants.vue";
import Speakers from "../pages/Speakers.vue";
import Programs from "../pages/Programs";
import Sponsors from "../pages/Sponsors.vue";
import Stands from "@/components/event/Stands";
import Faq from "../pages/Faq";
import Documents from "../pages/Documents";
import Album from "../pages/Album";
import Maps from "../pages/AreaMaps";
import SurveyList from "@/components/event/SurveyList";
import Session from "@/components/event/Session";
import Sessions from "@/components/event/Sessions";
import Networking from "@/components/event/Networking";
import Network from "@/components/event/Network";
import Vote from "@/components/event/Vote";
import StandDetail from "@/components/event/StandDetail";
import { props } from "vue-add-to-calendar";

Vue.use(Router);

export default new Router({
  mode: "history",
  linkExactActiveClass: "is-active",
  routes: [
    {
      path: "/:slug",
      component: Application,
      children: [
        {
          path: "login",
          component: Login,
          name: "login",
          props: true
        },
        {
          path: "register",
          component: Register,
          name: "register",
          props: true
        },
        {
          path: "forgot-password",
          component: ForgotPassword,
          name: "forgot-password",
          props: true
        },
        {
          path: "/",
          name: "home",
          component: Home
        },
        {
          path: "event/:id",
          name: "event",
          component: EventWrapper,
          children: [
            {
              path: "live/:session_id",
              name: "session",
              component: Session
            },
            {
              path: "sessions",
              name: "livestreams",
              component: Sessions
            },
            {
              path: "networking",
              name: "networking",
              component: Networking
            },
            {
              path: "room/:network_id",
              name: "room",
              component: Network
            },
            {
              path: "exhibition",
              name: "stands",
              component: Stands
            },
            {
              path: "booth/:stand_id",
              name: "booth",
              component: StandDetail
            },
            {
              path: "sponsors",
              name: "Sponsors",
              component: Sponsors
            },
            {
              path: "speakers",
              name: "Speakers",
              component: Speakers
            },
            {
              path: "album",
              name: "Gallery",
              component: Album
            },
            {
              path: "program",
              name: "Program",
              component: Programs
            },
            {
              path: "maps",
              name: "AreaMaps",
              component: Maps
            },
            {
              path: "faq",
              name: "QuestionLibrary",
              component: Faq
            },
            {
              path: "documents",
              name: "Documents",
              component: Documents
            },
            {
              path: "attendees",
              name: "Participants",
              component: Participants
            },
            {
              path: "",
              component: Event,
              children: [
                {
                  path: "",
                  name: "event",
                  component: EventInfo
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  scrollBehavior: function (to, from, savedPosition) {
    if(document.getElementsByClassName('router-container').length > 0)
    {
      document.getElementsByClassName('router-container')[0].scrollTo({top:0,left:0,behavior:"smooth"});
    }


  },
});



// WEBPACK FOOTER //
// ./src/router/index.js